"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isSubscription = function (subscription) { return typeof subscription.unsubscribe === 'function'; };
var isObservable = function (observable) { return typeof observable.subscribe === 'function'; };
exports.initSubscriptions = function (instance) {
    instance.AutoSubscriptionsList =
        instance.AutoSubscriptionsPropertyKeys
            .map(function (key) { return instance[key]; })
            .filter(Boolean)
            .map(function (value) { return typeof value === 'function' ? value() : value; })
            .filter(isObservable)
            .map(function (observable) { return observable.subscribe(); });
};
exports.removeSubscriptions = function (instance) {
    instance.AutoSubscriptionsList
        .filter(isSubscription)
        .forEach(function (subscription) { return subscription.unsubscribe(); });
    instance.AutoSubscriptionsList = [];
};
var AutoAutoSubscriptionsInit = function (originalInit) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (Array.isArray(this.AutoSubscriptionsPropertyKeys)) {
            exports.initSubscriptions(this);
        }
        if (originalInit) {
            return originalInit.bind(this).apply(void 0, args);
        }
    };
};
var AutoAutoSubscriptionsDestroy = function (originalDestroy) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (Array.isArray(this.AutoSubscriptionsList)) {
            exports.removeSubscriptions(this);
        }
        if (originalDestroy) {
            return originalDestroy.bind(this).apply(void 0, args);
        }
    };
};
function AutoSubscriptions(metadata) {
    if (metadata === void 0) { metadata = { init: 'ngOnInit', destroy: 'ngOnDestroy' }; }
    return function (constructor) {
        var originalInit = constructor.prototype[metadata.init];
        var originalDestroy = constructor.prototype[metadata.destroy];
        if (!originalInit) {
            throw new Error("Can't find init function with: " + metadata.init);
        }
        if (!originalDestroy) {
            throw new Error("Can't find destroy function with " + metadata.destroy);
        }
        constructor.prototype[metadata.init] = AutoAutoSubscriptionsInit(originalInit);
        constructor.prototype[metadata.destroy] = AutoAutoSubscriptionsDestroy(originalDestroy);
    };
}
exports.AutoSubscriptions = AutoSubscriptions;
function AutoSubscription(target, propertyKey) {
    target.AutoSubscriptionsPropertyKeys = (target.AutoSubscriptionsPropertyKeys || []).concat([propertyKey]);
}
exports.AutoSubscription = AutoSubscription;
//# sourceMappingURL=auto-subscriptions.js.map